import React, { forwardRef } from "react";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import Button from "atoms/buttons/button";
import PublishStatus from "models/enumerations/publish-status";
import { EnhancedContentPanelFooterProps } from "../enhanced-content-panel-footer";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

interface EnhancedContentPublishActionProps
    extends Pick<EnhancedContentPanelFooterProps, "enhancedContent"> {
    onClick: () => void;
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Components
// -----------------------------------------------------------------------------------------

const EnhancedContentPublishAction = forwardRef<
    HTMLButtonElement,
    EnhancedContentPublishActionProps
>((props, ref) => {
    const { enhancedContent, onClick } = props;

    const { globalState } = useGlobalState();

    const canPublish =
        ((globalState.currentIdentity?.isAdmin() ||
            globalState.currentIdentity?.isPublisher()) &&
            (enhancedContent.getPublishStatus() === PublishStatus.Unpublished ||
                enhancedContent.hasUnpublishedChanges())) ??
        false;

    const buttonText = enhancedContent.hasUnpublishedChanges()
        ? "Publish Changes"
        : "Publish";

    // -----------------------------------------------------------------------------------------
    // #region Render
    // -----------------------------------------------------------------------------------------

    if (!canPublish) {
        return null;
    }

    return (
        <Button
            accessibleText={`${buttonText} NFPA Insights`}
            ref={ref}
            onClick={onClick}>
            {buttonText}
        </Button>
    );

    // #endregion Render
});

// #endregion Components

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default EnhancedContentPublishAction;

// #endregion Exports
